import { useLayoutEffect } from "react";
import { useDndContext } from "@dnd-kit/core";

interface BoardOrphanedDragGuardProps {
    isPointerDrag: boolean;
    onOrphaned: () => void;
}

/**
 * dnd-kit calls `onDragEnd` only once its own drag has rendered, so a drag
 * that starts and ends within one render (a quick click that slides past the
 * activation distance) ends with no callback. The board would keep that card
 * as an empty slot; this lets go of the drag once dnd-kit has none. Render it
 * inside the board's `DndContext`.
 */
export const BoardOrphanedDragGuard = ({
    isPointerDrag,
    onOrphaned,
}: Readonly<BoardOrphanedDragGuardProps>) => {
    const { active } = useDndContext();
    const isOrphaned = isPointerDrag && active === null;
    useLayoutEffect(() => {
        if (isOrphaned) {
            onOrphaned();
        }
    }, [isOrphaned, onOrphaned]);
    return null;
};
